export default __webpack_public_path__ + "static/performance-e8fac42b55b665f33b486bf431e92b4e.gif";